import api from "./client";
function postAnalysisInput(path, input, fields = {}) {
    if (input?.mode === "feed_ids") {
        return api
            .post(path, { feed_ids: input.feed_ids, ...fields })
            .then((res) => res.data);
    }
    if (input?.mode === "zips" && input.files?.length) {
        const fd = new FormData();
        input.files.forEach((f, i) => {
            fd.append(`gtfs_${String(i).padStart(2, "0")}`, f.blob, f.filename || `feed_${i}.zip`);
        });
        fd.append("feed_count", String(input.files.length));
        fd.append("payload", JSON.stringify(fields));
        // Content-Type'ı elle set etme — boundary tarayıcı/axios eklemeli
        return api.post(path, fd).then((res) => res.data);
    }
    return api
        .post(path, { tables: input?.tables, ...fields })
        .then((res) => res.data);
}
const analizApi = {
    /** Ortak from-tables / zip / feed_ids gönderimi */
    postAnalysisInput,
    networkHealth() {
        return api.get("/network/health").then((res) => res.data);
    },
    isochrone(params) {
        return api.post("/network/isochrone", params).then((res) => res.data);
    },
    /** GTFS + OTP: saat seçimli toplu taşıma izokronu */
    transitIsochrone(params) {
        return api
            .post("/network/transit-isochrone", params)
            .then((res) => res.data);
    },
    /**
     * Çoklu profil + süre katmanı.
     * arrive_by=true → “buraya kim kaç dk’da gelebilir”
     */
    accessIsochrone(params) {
        return api
            .post("/network/isochrone/access", params)
            .then((res) => res.data);
    },
    listNetworkStacks() {
        return api.get("/network/stacks").then((res) => res.data);
    },
    getNetworkStack(stackId) {
        return api.get(`/network/stacks/${stackId}`).then((res) => res.data);
    },
    buildNetworkStack(body) {
        return api.post("/network/stacks/build", body).then((res) => res.data);
    },
    buildNetworkStackMultipart(files, fields = {}) {
        const fd = new FormData();
        files.forEach((f, i) => {
            fd.append(`gtfs_${String(i).padStart(2, "0")}`, f.blob, f.filename || `feed_${i}.zip`);
        });
        fd.append("feed_count", String(files.length));
        fd.append("payload", JSON.stringify(fields));
        return api.post("/network/stacks/build", fd).then((res) => res.data);
    },
    promoteNetworkStack(stackId) {
        return api
            .post(`/network/stacks/${stackId}/promote`, {})
            .then((res) => res.data);
    },
    deleteNetworkStack(stackId) {
        return api.delete(`/network/stacks/${stackId}`).then((res) => res.data);
    },
    listJobs() {
        return api.get("/analiz/jobs").then((res) => res.data);
    },
    getJob(jobId) {
        return api.get(`/analiz/jobs/${jobId}`).then((res) => res.data);
    },
    runCatchmentIsochrones(body) {
        return api.post("/analiz/catchment/isochrones/run", body).then((res) => res.data);
    },
    listCatchmentIsochrones(params) {
        return api.get("/analiz/catchment/isochrones", { params }).then((res) => res.data);
    },
    listCatchmentMetrics(params) {
        return api.get("/analiz/catchment/metrics", { params }).then((res) => res.data);
    },
    loadSamplePopulation() {
        return api.post("/analiz/population/sample").then((res) => res.data);
    },
    runPopulationOverlay(body) {
        return api.post("/analiz/population/overlay/run", body).then((res) => res.data);
    },
    latestPopulation(params) {
        return api
            .get("/analiz/population/datasets/latest", { params })
            .then((res) => res.data);
    },
    /** İzokron poligonları içindeki nüfus + yaş bandı kırılımı */
    populationCoverage(body) {
        return api.post("/analiz/population/coverage", body).then((res) => res.data);
    },
    /** Mahalle bazlı arz-talep açığı (transit desert) analizi */
    transitDesertFromTables(bodyOrInput, fields) {
        if (bodyOrInput &&
            "mode" in bodyOrInput &&
            (bodyOrInput.mode === "feed_ids" ||
                bodyOrInput.mode === "zips" ||
                bodyOrInput.mode === "tables")) {
            return postAnalysisInput("/analiz/transit-desert/from-tables", bodyOrInput, fields || {});
        }
        return api
            .post("/analiz/transit-desert/from-tables", bodyOrInput)
            .then((res) => res.data);
    },
    corridorDefaults() {
        return api.get("/analiz/corridor/params/defaults").then((res) => res.data);
    },
    corridorFromTables(bodyOrInput, fields) {
        if (bodyOrInput &&
            "mode" in bodyOrInput &&
            (bodyOrInput.mode === "feed_ids" ||
                bodyOrInput.mode === "zips" ||
                bodyOrInput.mode === "tables")) {
            return postAnalysisInput("/analiz/corridor/from-tables", bodyOrInput, fields || {});
        }
        return api
            .post("/analiz/corridor/from-tables", bodyOrInput)
            .then((res) => res.data);
    },
    corridorPassagesFromTables(bodyOrInput, fields) {
        if (bodyOrInput &&
            "mode" in bodyOrInput &&
            (bodyOrInput.mode === "feed_ids" ||
                bodyOrInput.mode === "zips" ||
                bodyOrInput.mode === "tables")) {
            return postAnalysisInput("/analiz/corridor/passages-from-tables", bodyOrInput, fields || {});
        }
        return api
            .post("/analiz/corridor/passages-from-tables", bodyOrInput)
            .then((res) => res.data);
    },
    runCorridorSync(body) {
        return api.post("/analiz/corridor/run", body).then((res) => res.data);
    },
    listCorridors(params) {
        return api.get("/analiz/corridor/list", { params }).then((res) => res.data);
    },
    getCorridor(corridorId) {
        return api.get(`/analiz/corridor/${corridorId}`).then((res) => res.data);
    },
    serviceAvailabilityDefaults() {
        return api
            .get("/analiz/service-availability/params/defaults")
            .then((res) => res.data);
    },
    serviceAvailabilityFromTables(bodyOrInput, fields) {
        if (bodyOrInput &&
            "mode" in bodyOrInput &&
            (bodyOrInput.mode === "feed_ids" ||
                bodyOrInput.mode === "zips" ||
                bodyOrInput.mode === "tables")) {
            return postAnalysisInput("/analiz/service-availability/from-tables", bodyOrInput, fields || {});
        }
        return api
            .post("/analiz/service-availability/from-tables", bodyOrInput)
            .then((res) => res.data);
    },
    serviceAvailabilityReclassify(body) {
        return api
            .post("/analiz/service-availability/reclassify", body)
            .then((res) => res.data);
    },
    serviceAvailabilityGridPrepare(bodyOrInput, fields) {
        if (bodyOrInput &&
            "mode" in bodyOrInput &&
            (bodyOrInput.mode === "feed_ids" ||
                bodyOrInput.mode === "zips" ||
                bodyOrInput.mode === "tables")) {
            return postAnalysisInput("/analiz/service-availability/grid/prepare", bodyOrInput, fields || {});
        }
        return api
            .post("/analiz/service-availability/grid/prepare", bodyOrInput)
            .then((res) => res.data);
    },
    serviceAvailabilityGridMaterialize(body) {
        return api
            .post("/analiz/service-availability/grid/materialize", body)
            .then((res) => res.data);
    },
    /** Mahalle/ilçe hizmet kapsama choropleth */
    adminCoverageFromTables(body) {
        return api
            .post("/analiz/admin-coverage/from-tables", body)
            .then((res) => res.data);
    },
    boundaries(params) {
        return api.get("/analiz/boundaries", { params }).then((res) => res.data);
    },
    /**
     * Duraklar arası otomatik shape üret (Valhalla /route veya düz çizgi)
     */
    generateShape(body) {
        return api.post("/analiz/shape/generate", body).then((res) => res.data);
    },
    /** Köşe bırakılınca yerel snap (locate + komşu segment) */
    snapShapeVertex(body) {
        return api.post("/analiz/shape/snap-vertex", body).then((res) => res.data);
    },
    /** Tüm güzergahı yola yapıştır (map_snap) */
    snapShape(body) {
        return api.post("/analiz/shape/snap", body).then((res) => res.data);
    },
    /** Tek / çoklu durak buffer nüfusu */
    stopPopulation(body) {
        return api.post("/analiz/stop/population", body).then((res) => res.data);
    },
    /**
     * Çoklu hat için nüfus hesaplama
     */
    routePopulation(body) {
        return api.post("/analiz/route/population", body).then((res) => res.data);
    },
};
export default analizApi;
